
<ion-content>
  @if (list.length > 0) {
    <ion-list>
      @for (item of list; track item) {
        <ion-item [title]="item.description">
          <ion-checkbox [(ngModel)]="item.checked" slot="start" labelPlacement="end" (ngModelChange)="itemChecked(item)">
            {{item.description}}
          </ion-checkbox>
        </ion-item>
      }
    </ion-list>
  }

  @if (list.length == 0) {
    <p class="no-content">Keine Anhänge</p>
  }

</ion-content>